import { stringify } from 'query-string';

import { addError } from '@src/validations';
import { apiGet } from '@src/services/api/helpers';

async function checkInvalidStates(values, source) {
    const platformIds = values[source.platforms] || [];
    const productIds = values[source.products] || [];
    const selectedStates = values[source.states] || [];

    if ((platformIds.length === 0 && productIds.length === 0) || selectedStates.length === 0) {
        return [];
    }

    const query = {};
    if (platformIds.length > 0) {
        query['platform_ids[]'] = platformIds;
    }

    if (productIds.length > 0) {
        query['product_ids[]'] = productIds;
    }

    const url = `/states?${stringify(query)}`;

    try {
        const response = await apiGet(url);
        const { data } = response;
        const validStates = data.states.map((state) => state.abbreviation.toLowerCase());

        let invalidStates = selectedStates.filter((abbr) => !validStates.includes(abbr));
        if (invalidStates.length > 0) {
            invalidStates = invalidStates.map((abbr) => abbr.toUpperCase());
        }

        return invalidStates;
    } catch {
        return [];
    }
}

export async function validateStates(values, errors, source) {
    const invalidStates = await checkInvalidStates(values, source);
    if (invalidStates.length > 0) {
        addError(
            errors,
            source.states,
            `Platform and/or product not available in selected state(s): ${invalidStates.join(', ')}`,
        );
    }
}
